import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pages } from '../../seo/pages';

// Cada ruta ya sale con su propio HTML (title/meta correctos para buscadores).
// Este componente mantiene esos datos al navegar dentro de la app sin recargar.
const byPath = Object.fromEntries(pages.map((p) => [p.path, p]));

const setAttr = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export default function PageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalized = pathname.endsWith('/') ? pathname : pathname + '/';
    const page = byPath[normalized.toLowerCase()];
    if (!page) return;
    document.title = page.title;
    setAttr('meta[name="description"]', 'content', page.description);
    setAttr('link[rel="canonical"]', 'href', page.url);
    setAttr('meta[property="og:title"]', 'content', page.title);
    setAttr('meta[property="og:description"]', 'content', page.ogDescription);
    setAttr('meta[property="og:url"]', 'content', page.url);
    setAttr('meta[name="twitter:title"]', 'content', page.title);
    setAttr('meta[name="twitter:description"]', 'content', page.ogDescription);
  }, [pathname]);

  return null;
}
